import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';
import { runTaskToCompletion } from './taskService';

export const fetchAudioResources = (projectId, episodeId) => {
  const query = new URLSearchParams();
  query.set('projectId', projectId);
  if (episodeId) query.set('episodeId', episodeId);
  return authenticatedFetch(`${API_HOST}/api/resource/audios?${query.toString()}`);
};

export const fetchMiniStoryboardMusicCues = (projectId, episodeId) => {
  const query = new URLSearchParams();
  query.set('projectId', projectId);
  query.set('episodeId', episodeId);
  return authenticatedFetch(`${API_HOST}/api/episode-mini-storyboard/music/cues?${query.toString()}`);
};

export const updateMiniStoryboardMusicCue = (payload) => {
  return authenticatedFetch(`${API_HOST}/api/episode-mini-storyboard/music/cue`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const planMiniStoryboardMusicCues = (payload, options = {}) => {
  return runTaskToCompletion('EPISODE_MINI_STORYBOARD_MUSIC_PLAN', payload, {
    provider: payload.provider || payload.textProvider || 'WANGSUGEM',
    source: 'episode_mini_storyboard_music_plan',
    projectId: payload.projectId,
    episodeId: payload.episodeId,
    timeoutMs: options.timeoutMs || 30 * 60 * 1000,
    intervalMs: options.intervalMs || 3000,
    onProgress: options.onProgress,
    signal: options.signal,
  });
};

export const planScriptMusicCues = (payload, options = {}) => {
  return runTaskToCompletion('MUSIC_AUDIO_SCRIPT_PLAN', payload, {
    provider: payload.provider || payload.textProvider || 'WANGSUGEM',
    source: 'music_audio_script_plan',
    projectId: payload.projectId,
    episodeId: payload.episodeId,
    timeoutMs: options.timeoutMs || 30 * 60 * 1000,
    intervalMs: options.intervalMs || 3000,
    onProgress: options.onProgress,
    signal: options.signal,
  });
};

export const generateMusicAudio = (payload, options = {}) => {
  return runTaskToCompletion('MUSIC_AUDIO_GENERATE', payload, {
    provider: 'xingtu_audio',
    source: payload.source || 'music_audio_agent',
    projectId: payload.projectId,
    episodeId: payload.episodeId,
    timeoutMs: options.timeoutMs || 30 * 60 * 1000,
    intervalMs: options.intervalMs || 3000,
    onProgress: options.onProgress,
    signal: options.signal,
  });
};
